import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GitService {
  private http = inject(HttpClient);
  // The API URL defaults to relative paths because they are proxied or resolved directly by the Angular dev server / Nginx
  private baseUrl = '/api/git';

  getCredentials(): Observable<any> {
    return this.http.get(`${this.baseUrl}/credentials`);
  }

  saveCredentials(token: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/credentials`, { token });
  }

  disconnect(): Observable<any> {
    return this.http.delete(`${this.baseUrl}/credentials`);
  }

  getSelection(): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/selection`);
  }

  saveSelection(selection: any[]): Observable<any> {
    return this.http.post(`${this.baseUrl}/selection`, { selection });
  }

  listRepositories(): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/repositories`);
  }

  listBranches(owner: string, repo: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/repositories/${owner}/${repo}/branches`);
  }

  downloadBackup(): Observable<any> {
    return this.http.get(`${this.baseUrl}/backup`, {
      responseType: 'blob',
      observe: 'response'
    });
  }
}
